export const navLinks = [
  { id: 1, linkText: "Anasayfa", url: "/" },
  { id: 2, linkText: "İlanlar", url: "/adverts" },
  { id: 3, linkText: "Satılık", url: "/sale" },
  { id: 4, linkText: "Kiralık", url: "/rent" },
  { id: 5, linkText: "Şubelerimiz", url: "/subelerimiz" },
  { id: 6, linkText: "Hakkımızda", url: "/about" },
  { id: 7, linkText: "İletişim", url: "/contact" },
];
